import { Component, OnInit } from '@angular/core';
import { MarianomGeneral } from '../../marianom-general.service';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';

@Component({
    selector: 'modal-mensaje-mmax',
    templateUrl: './modal-mensaje-mmax.component.html',
    styleUrls: ['./modal-mensaje-mmax.component.scss']
})
export class ModalMensajeMmaxComponent implements OnInit {

    title: string = '';
    message: string = '';

    constructor(private serv: MarianomGeneral, private modal: ModalService) { }

    ngOnInit(): void {
        this.serv.mensajeModal$.subscribe(data => {
            if (data) {
                this.title = data.title;
                this.message = data.message;
            }
        });
    }

    cerrar() {
        this.modal.close('modal-mensaje');
    }

}
